<div>
  <canvas class="signature-pad-canvas" #canvas></canvas>
  <div class="d-flex justify-content-between mx-auto">
    <div>
      <button mat-button class="btn-lg py-4 px-4 mx-3 px-sm-5 font-button button-action-cancel" (click)="cancel()">{{'BUTTON_BACK' | translate}}</button>
      <button mat-button class="btn-lg py-4 px-4 mx-3 px-sm-5 font-button button-action-cancel" (click)="reset()">{{'BUTTON_RESET' | translate}}</button>
    </div>
    <button mat-button class="btn-lg py-4 px-4 mx-3 px-sm-5 font-button button-action-base" [ngStyle]="UIUtilityService.getBankButtonStyle()" (click)="save()"> {{'BUTTON_SIGN' | translate}} </button>
  </div>
</div>